import { appConstants } from '../helpers/app-constants';


// RETURN ERRORS
export const returnErrors = (msg, status, id = null) => {
  return {
    type: appConstants.GET_ERRORS,
    payload: { msg, status, id },
  };
};

// CLEAR ERRORS
export const clearErrors = () => {
  return {
    type: appConstants.CLEAR_ERRORS,
  };
};